<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="lot && !loading">
      <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
        <span slot="left-title">Edition des documents du lot {{lot.ref}}</span>
      </sticky>
      <div class="columns is-gapless has-bg-light is-padding">
        <div class="column is-8 is-8-widescreen is-padding-right">
          <div class="has-bg-white is-radius-large is-border">
            <form @submit.prevent.stop="submit">
              <div class="columns is-multiline is-margin-top-small">
                <div class="column is-padding-bottom-xsmall">
                  <div class="columns">
                    <div class="column is-12">
                      <h2 class="title is-2 has-text-weight-black">Plan</h2>
                      <div class="field">
                        <label class="label">Téléchargez le plan
                          <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'5wPdDg9dTyOkmewUyKySOa'">
                            <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                          </span>
                        </label>
                        <upload-file @upload="uploadPlan" :placeholder="'Sélectionner le plan'"
                                    :documents="[lot.plan]"></upload-file>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-12">
                      <h2 class="title is-2 has-text-weight-black">Documents</h2>
                      <div class="field">
                        <label class="label">Téléchargez des documents
                          <span class="is-size-3 is-margin-left-xsmall" v-helper.right="'5wPdDg9dTyOkmewUyKySOa'">
                            <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                          </span>
                        </label>
                        <upload-file @upload="uploadDocument" :placeholder="'Sélectionner document(s)'"
                                    :documents="lot.documents" :default-names="lotDocumentsNameData"></upload-file>
                      </div>
                    </div>
                    <!-- <div class="column" v-if="lot.documents && lot.documents.length">
                      <div class="columns is-multiline">
                        <div class="column is-12">
                          <h4 class="title is-4">État des documents</h4>
                        </div>
                        <div class="column">
                          <p v-for="n in lotDocumentsNameData" :key="n" class="is-padding-bottom-small">
                            <span><i class="fal fa-check" v-if="lotDocumentsName.includes(n)"></i></span>
                            <span :class="{'has-text-grey' : !lotDocumentsName.includes(n)}">{{n}}</span>
                          </p>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
                <div class="column is-6">
                  <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                    <span>Annuler</span>
                  </a>
                </div>
                <div class="column is-6">
                  <button class="button is-success is-uppercase is-fullwidth has-text-white"
                    :class="{'is-loading':loading}"
                    type="submit"
                    :disabled="loading">
                    <span v-if="loading"><i class="fal fa-spinner-third"></i></span>
                    <span v-else>Valider</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { mapState } from 'vuex'

  export default {
    name: 'LotDocumentEdit',
    data () {
      return {
        lot: null,
        loading: true,
        id: this.$route.params.id,
        pictures: [],
        documents: [],
        // plan: [],
        route: this.$route
      }
    },
    mixins: [DefaultValues],
    computed: {
      ...mapState(['currentUser']),
      lotDocumentsName () {
        return this.lot.documents.map(e => {
          return e.filename
        })
      }
    },
    methods: {
      submit (redirect = false) {
        console.log('submit')
        this.loading = true
        this.$api.lotService.put(this.id, this.lot).then(r => {
          this.$notify({
            type: 'is-success',
            text: 'Le lot a bien été mise à jour'
          })
          this.loading = false
          if (redirect) {
            this.$router.push({name: 'LotVue', params: {id: this.id}})
          } else {
            this.lot = r.data
            this.initValues(r.data)
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du lot.'
          })
        })
      },
      getLot () {
        this.loading = true
        this.$api.lotService.getOne(this.id).then(r => {
          this.loading = false
          this.lot = r.data
          this.initValues(this.lot)
        }).catch(() => {
          this.loading = false
        })
      },
      uploadImage (e) {
        e.map((el) => {
          return this.pictures.push(el)
        })
        this.$set(this.lot, 'pictures', this.pictures)
      },
      uploadDocument (e) {
        if (e.cropped) this.documents.splice(e.croppedIndex, 1, e[0])
        else e.map(el => this.documents.push(el))

        this.$set(this.lot, 'documents', this.documents)
        this.submit()
      },
      uploadPlan (e) {
        if (e.length > 0) {
          this.$set(this.lot, 'plan', e[0])
          // this.$set(this, 'plan', e[0])
        } else {
          this.$set(this.lot, 'plan', null)
          // this.$set(this, 'plan', [])
        }
        this.submit()
      },
      deleteDocument (array, idx) {
        array.splice(idx, 1)
      },
      initValues (lot) {
        if (!Array.isArray(lot.pictures)) lot.pictures = []
        this.pictures = lot.pictures

        if (!Array.isArray(lot.documents)) lot.documents = []
        this.documents = lot.documents

        // if (lot.plan) {
        //   this.plan = [lot.plan]
        // }
      }
    },
    created () {
      this.getLot()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotDocumentEdit.vue